import type { QueryClient } from '@tanstack/react-query'
import { boardKeys } from '../api/queries'
import type { Board } from '../model/schema'

// Патч доски в detail + list-кэше проекта — rename применяет оптимистично, откат
// на ошибке. Ключей, которых нет в кэше, не касается (no-op).
export function patchBoardCache(
  qc: QueryClient,
  board: { id: string; projectId: string },
  patch: Partial<Board>,
): void {
  qc.setQueryData<Board>(boardKeys.detail(board.id), (b) => (b ? { ...b, ...patch } : b))
  qc.setQueryData<Board[]>(boardKeys.list(board.projectId), (list) =>
    list?.map((b) => (b.id === board.id ? { ...b, ...patch } : b)),
  )
}
